// src/services/countryStateCityService.js

class CountryStateCityAPI {
  constructor(apiKey) {
    this.apiKey = apiKey;
    this.baseURL = 'https://api.countrystatecity.in/v1';
  }

  async request(endpoint) {
    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, {
        headers: {
          'X-CSCAPI-KEY': this.apiKey,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Invalid API key. Please check your credentials.');
        } else if (response.status === 429) {
          throw new Error('Rate limit exceeded. Please try again later.');
        } else {
          throw new Error(`API error: ${response.status}`);
        }
      }

      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  async getCountries() {
    return await this.request('/countries');
  }

  async getStates(countryCode) {
    return await this.request(`/countries/${countryCode}/states`);
  }

  async getCities(countryCode, stateCode = null) {
    const endpoint = stateCode 
      ? `/countries/${countryCode}/states/${stateCode}/cities`
      : `/countries/${countryCode}/cities`;
    return await this.request(endpoint);
  }

  async getCountryDetails(countryCode) {
    return await this.request(`/countries/${countryCode}`);
  }
}

export default CountryStateCityAPI;
